module.exports = __webpack_public_path__ + "static/media/40th-bday.74366c59.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/40th-bday.png
// module id = 197
// module chunks = 0